// WithHideMessage.js
'use strict';
import { connect } from 'react-redux';

import {
  FEATURE_HIDE_POST,
  JWT_SCOPE_MESSAGE_HIDE,
} from '../RemoteConfigKeys.js';

import WithHideMessage from '../component/WithHideMessage.jsx';

import toggleModal from '../action/toggleModal.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

const mapStateToProps = (state, { messageId }) => {
  return {
    meId: getMeData(state, 'id'),
    senderId: getMessageData(state, messageId, 'senderId'),
    isHideMessageEnabled: getRemoteConfigData(state, FEATURE_HIDE_POST) === 1,
    isHidePermissionMatched: getIsPermissionMatched(
      state,
      JWT_SCOPE_MESSAGE_HIDE
    ),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithHideMessage);
